<div>
  @if (isInfrastructureDelegate()) {
    <overflow-menu-button [enabled]="selfServiceEnabled()">
      <div
        class="overflow-menu__item"
        (click)="selectItem('vlan-l2vpn')"
        [matTooltip]="'Selfservice.Tooltip.Vlan' | translate"
        [matTooltipPosition]="'above'"
      >
        {{ "OverflowMenu.ModifyVlan" | translate }}
      </div>
      <div
        class="overflow-menu__item"
        (click)="selectItem('add-port')"
        [matTooltip]="'Selfservice.Tooltip.AddPort' | translate"
        [matTooltipPosition]="'above'"
      >
        {{ "OverflowMenu.AddPort" | translate }}
      </div>
      <div
        class="overflow-menu__item"
        (click)="selectItem('remove-port')"
        [matTooltip]="'Selfservice.Tooltip.RemovePort' | translate"
        [matTooltipPosition]="'above'"
      >
        {{ "OverflowMenu.RemovePort" | translate }}
      </div>
    </overflow-menu-button>
  }
</div>
